import queries from '@apis/queries';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { useQuery } from '@tanstack/react-query';

function useDiscounts() {
    const { shopId, totalAmount, orderLines } = useCalculatedRequest();
    const selectedItemIds = orderLines.map((it) => it.shopItemId);
    // shopId 단위로 해당 매장의 쿠폰/포인트/선물 목록을 서버에서 가져옴
    const { data } = useQuery({
        ...queries.discounts.list(shopId),
        enabled: !!shopId,
    });
    // 장바구니에 couponUsable=true인 상품이 하나라도 있어야 쿠폰 섹션을 표시
    // (쿠폰 사용 불가 상품만 담겨 있으면 전체 쿠폰 목록을 숨김)
    const couponUsable = orderLines.some((line) => line.couponUsable);
    const coupons = couponUsable ? data?.coupons
        ?.filter((coupon) => {
            const { minOrderAmount, discountMethod, requiredItemIds } = coupon;
            if (discountMethod === 'BOGO' && !orderLines.some((line) => line.quantity > 1)) {
                // 1+1 쿠폰은 동일 상품을 2개 이상 담았을 때만 적용 가능하므로
                // 수량 >= 2인 상품이 없으면 목록에서 제외
                return false;
            }
            // 필수주문 상품 처리
            if (requiredItemIds && requiredItemIds.length !== 0) {
                const included = selectedItemIds.some((itemId) => requiredItemIds.includes(itemId));
                if (!included) {
                    return false;
                }
            }
            // 현재 주문 금액이 최소 주문 금액 미달이면 쿠폰 숨김
            return !(minOrderAmount !== undefined && minOrderAmount > totalAmount);
        }) : [];

    return {
        coupons,
        points: data?.points,
        gifts: data?.gifts,
    };
}

export default useDiscounts;
